module.exports = __webpack_public_path__ + "img/bx.c6a9371d.png";